// extracted by mini-css-extract-plugin
module.exports = {"smallDropdownIcon":"invoices_smallDropdownIcon__rXfee","smallButtonText":"invoices_smallButtonText__27G4R"};